import { Formik, FormikHelpers } from "formik";
import { UserFormInitValues } from "../../interfaces/fe.interfaces";
import styles from "./styles.module.scss";
import Form from "./Form";
import { http } from "../../api/utils/http";
import { toast } from "react-toastify";
import { addUser } from "../../api/config";
import { PostOrPutUserResponse } from "../../interfaces/be.interfaces";
import { AxiosResponse } from "axios";
import { validateAddOrEditUser } from "../../utils/validationSchemas";

interface AddUserDialogProps {
  callback: () => void | Promise<void>;
  onCancelClick: () => void | Promise<void>;
}

// Initial values for add user form
const initialValues: UserFormInitValues = {
  vendor_id: "",
  email: "",
  name: "",
  password: "",
  role_ids: [],
  confirmPassword: "",
  isPasswordFieldVisible: true,
  roles: [],
  customer: null,
  customer_point_of_contact: false,
  manage_customer_ids: [],
  managed_product_ids: [],
};

const AddUserDialog = (props: AddUserDialogProps) => {
  // Handler for form submit to save user
  const handleAddUser = (values: UserFormInitValues, { setSubmitting }: FormikHelpers<UserFormInitValues>): void => {
    const payload = {
      role_ids: values.role_ids,
      name: values.name,
      email: values.email,
      password: values.password,
      vendor_id: values.vendor_id,
      customer_point_of_contact: values.customer_point_of_contact,
      manage_customer_ids: values.manage_customer_ids.length ? values.manage_customer_ids : null,
      managed_product_ids: values.managed_product_ids
    };

    // Success callback for /add-user API
    const onSuccess = ({ data: response }: AxiosResponse<PostOrPutUserResponse>) => {
      setSubmitting(false);
      if (response?.status) {
        // Display success toast and call parent callback to refresh the table
        toast.success(response?.message);
        props.callback();

        // Close the dialog
        props.onCancelClick();
      } else {
        toast.error(response?.message);
      }
    };

    // Calls /add-user API
    http.makePostRequest<PostOrPutUserResponse, { message: string }>(
      addUser,
      onSuccess,
      (error) => {
        setSubmitting(false);
        toast.error(error?.response?.data?.message);
      },
      payload
    );
  };

  return (
    <>
      <div className={styles.dialogContainer}>
        <Formik
          initialValues={initialValues}
          onSubmit={handleAddUser}
          onReset={props.onCancelClick}
          validationSchema={validateAddOrEditUser}>
          {(props) => <Form {...props} isEditForm={false} />}
        </Formik>
      </div>
    </>
  );
};

export default AddUserDialog;
